import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    required,
    ReferenceInput,
    SelectInput,
    useGetOne,
} from 'react-admin';
import { Sections } from '../../custom';
import { EditToolbar } from '../../common/EditToolbar';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';

const SectionEdit = () => {
    let { testSeriesId, testId, sectionId } = useParams();

    if (!testId) {
        return <LoadingSection />;
    }
    return (
        <Edit
            mutationMode={'pessimistic'}
            title={<SectionTitle />}
            redirect={() => {
                return `test-series/${testSeriesId}/tests/${testId}/sections`;
            }}
            resource={'sections'}
            id={sectionId}
        >
            <SimpleForm toolbar={<EditToolbar />}>
                <TextInput source="name" fullWidth validate={[required()]} />
            </SimpleForm>
        </Edit>
    );
};

const SectionTitle = () => {
    const record = useRecordContext<Sections>();
    return record ? <span className="capitalize">{record.name}</span> : null;
};

export default SectionEdit;
